import type { ShigoUser } from './model';
import { ShigoRole } from './permissions';

export enum NetworkAvailableFeature {
  Campaign = 'CAMPAIGN',
  AdUnit = 'AD_UNIT',
  A2v = 'A2V',
  Content = 'CONTENT',
  Immu = 'IMMU',
  LiveRamp = 'LIVE_RAMP',
  Email = 'EMAIL',
  Stitcher = 'STITCHER',
  BidCache = 'BID_CACHE',
  Owner = 'OWNER',
}

const knownNetworkFeatures = new Set<string>(Object.values(NetworkAvailableFeature));

export function normalizeNetworkFeatures(features: readonly string[]) {
  return features.filter((feature): feature is NetworkAvailableFeature =>
    knownNetworkFeatures.has(feature),
  );
}

export function isNetworkFeatureAllowed(
  user: Pick<ShigoUser, 'roles' | 'networkFeatures'>,
  feature: NetworkAvailableFeature,
) {
  return (
    user.roles.includes(ShigoRole.SuperAdmin) || (user.networkFeatures ?? []).includes(feature)
  );
}
